import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { SessionService } from '../other/session';
import { SessionExpiryService } from '../other/session-expiry';

export const authGuard: CanActivateChildFn = (_childRoute, state) => {
  const router = inject(Router);
  const sessionService = inject(SessionService);
  const sessionExpiry = inject(SessionExpiryService);

  // An expired session still has a token in storage until the teardown lands,
  // so the token alone is not enough to let a navigation through.
  if (sessionService.getSessionToken() && !sessionExpiry.isExpired()) {
    return true;
  }

  return router.createUrlTree(['login'], {
    // Remember the destination so login can send the user back to it.
    queryParams: state.url.startsWith('/main') ? { returnUrl: state.url } : {},
  });
};
